import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import phFeMale from "../../../assets/images/blurred2/goal/female/3.png";
import phMale from "../../../assets/images/blurred2/goal/male/3.png";
import ImageLoader from "../../../components/ImageLoader";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url, nextPageRoute } from "../../../utils/modules";

const imagesToPreload = [
  "/imoji/swag.png",
  "/imoji/thumb_down_1.png",
  "/imoji/thumb_down_1.png",
  "/imoji/irritating.png",
  "/imoji/thumb_up_1.png",
];
const buttonText = [
  t("travel_while_working.dream"),
  t("travel_while_working.traveling"),
  t("travel_while_working.sometimes"),
  t("travel_while_working.not_priority"),
];

const data = {
  male: {
    src: addS3Url("/staging/goal/male/3.png"),
    placeHolderImage: phMale,
  },
  female: {
    src: addS3Url("/staging/goal/female/3.png"),
    placeHolderImage: phFeMale,
  },
};
const TravelWithWork = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const gender = params.gender || "female";

  const handleNavigate = () =>
    nextPageRoute(
      navigate,
      `/${params.gender}/contentwritingrating`,
      dispatch,
      imagesToPreload
    );
  return (
    <MobileViewLayout>
      <div className="d-flex flex-column align-content-center justify-content-center position-relative px-4">
        <div className="d-flex flex-column justify-content-center w-100  age-selection-heading">
          <h1 className="fs30 text-center fw-bolder age-selection-heading pt-0 m-0 pb-0 fs30">
            <Trans i18nKey={"travel_while_working.question"} />
          </h1>
          <div
            className="d-flex flex-column gap-4"
            style={{ paddingTop: "50px" }}
          >
            <div className="d-flex flex-row w-100 justify-content-between">
              {buttonText.slice(0, 2).map((item, index) => (
                <button
                  key={index}
                  tabIndex={0}
                  onClick={handleNavigate}
                  className="rounded text-black link-underline link-underline-opacity-0 button-highlight"
                  style={{
                    width: "47%",
                    paddingTop: "28px",
                    paddingBottom: "28px",
                    backgroundColor: "#F2F2F2",
                  }}
                >
                  <p
                    className="text-center m-0 fs18 "
                    style={{ fontWeight: 700 }}
                  >
                    {item}
                  </p>
                </button>
              ))}
            </div>
            <div className="d-flex flex-row w-100 justify-content-between ">
              {buttonText.slice(2, 4).map((item, index) => (
                <button
                  tabIndex={0}
                  key={index}
                  onClick={handleNavigate}
                  className="rounded text-black link-underline link-underline-opacity-0 button-highlight"
                  style={{
                    width: "47%",
                    paddingTop: "28px",
                    paddingBottom: "28px",
                    backgroundColor: "#F2F2F2",
                  }}
                >
                  <p
                    className="text-center m-0 fs18 "
                    style={{ fontWeight: 700 }}
                  >
                    {item}
                  </p>
                </button>
              ))}
            </div>
          </div>
          <div className="d-flex justify-content-center pt-3">
            <ImageLoader
              className="object-fit-contain"
              alt={params.gender}
              style={{ width: "70%" }}
              {...data[gender]}
            />
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default TravelWithWork;
